export default "__VITE_ASSET__4b6d6ea6__"